"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indentPadding = exports.dedentBlock = exports.indentBlock = exports.setIndent = exports.getActiveIndent = exports.INDENT_STEP_PX = exports.MAX_INDENT = void 0;
const slate_1 = require("slate");
const behavior_1 = require("../behavior");
const isElement = (node) => slate_1.Element.isElement(node);
const isFormattableBlock = (node) => !(0, behavior_1.isListType)(node.type) && node.type !== 'embed';
/** Maximum number of indent steps a block can have. */
exports.MAX_INDENT = 8;
/** Width of one indent step, in CSS pixels. */
exports.INDENT_STEP_PX = 24;
const getActiveIndent = (editor) => {
    const { selection } = editor;
    if (!selection)
        return 0;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
    if (!match)
        return 0;
    const [element] = match;
    const indent = element.indent;
    return typeof indent === 'number' && indent > 0 ? indent : 0;
};
exports.getActiveIndent = getActiveIndent;
const setIndent = (editor, indent) => {
    const clamped = Math.max(0, Math.min(exports.MAX_INDENT, Math.floor(indent)));
    if (!clamped) {
        slate_1.Transforms.unsetNodes(editor, 'indent', {
            match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
        });
        return;
    }
    slate_1.Transforms.setNodes(editor, { indent: clamped }, {
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
};
exports.setIndent = setIndent;
const indentBlock = (editor) => {
    (0, exports.setIndent)(editor, (0, exports.getActiveIndent)(editor) + 1);
};
exports.indentBlock = indentBlock;
const dedentBlock = (editor) => {
    const current = (0, exports.getActiveIndent)(editor);
    if (!current)
        return;
    (0, exports.setIndent)(editor, current - 1);
};
exports.dedentBlock = dedentBlock;
const indentPadding = (indent) => {
    if (!indent || indent < 1)
        return undefined;
    const steps = Math.min(exports.MAX_INDENT, Math.floor(indent));
    return steps * exports.INDENT_STEP_PX;
};
exports.indentPadding = indentPadding;
